import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_REMOVE_EMISSION_FACTOR = "REMOVE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const removeEmissionFactor = async (emissionFactorId: string): Promise<void> => {
  await emissionFactorsApi.emissionFactorsControllerDeleteEmissionFactor(
    emissionFactorId,
  );
};

export const useRemoveEmissionFactor = (
  user: UserProfileDto | null,
): {
  removeEmissionFactor: UseMutateFunction<void, unknown, string, unknown>;
  removeEmissionFactorEnabled: boolean;
  isSuccessRemoveEmissionFactor: boolean;
  isPendingRemoveEmissionFactor: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_REMOVE_EMISSION_FACTOR],
    mutationFn: enabled ? removeEmissionFactor : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    removeEmissionFactor: mutate,
    removeEmissionFactorEnabled: enabled,
    isSuccessRemoveEmissionFactor: isSuccess,
    isPendingRemoveEmissionFactor: isPending,
  };
};
